module.exports = __webpack_public_path__ + "static/media/return.e798b075.svg";